var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E7393E5C-5038-4593-B70A-C1DE4BB5BDD4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "questionnaire--Contact-information-eror",
    transform: "translate(-832.000000, -381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "free",
    transform: "translate(833.000000, 382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart;-action;-shop;-store;-buy;-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1111111,23.6111111 C11.4664714,23.6111111 11.8218317,23.4754775 12.0930989,23.20421 L25.9819878,9.31532111 C26.5245225,8.77278639 26.5245225,7.89388 25.9819878,7.35134528 C25.4394531,6.80881056 24.5605467,6.80881056 24.0180119,7.35134528 L11.1111111,20.2582467 L6.53754333,15.6846789 C5.99500861,15.1421442 5.11610222,15.1421442 4.5735675,15.6846789 C4.03103278,16.2272136 4.03103278,17.10612 4.5735675,17.6486547 L10.1291231,23.2042103 C10.4003906,23.4754775 10.7557508,23.6111111 11.1111111,23.6111111 Z",
    id: "Path",
    fill: "#617984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4188369,-0.5 C24.1191871,-0.5 31.1966147,6.57742763 31.1966147,15.2777778 C31.1966147,23.9781279 24.1191871,31.0555556 15.4188369,31.0555556 C6.71848679,31.0555556 -0.358940833,23.9781279 -0.358940833,15.2777778 C-0.358940833,6.57742753 6.71848661,-0.5 15.4188369,-0.5 Z",
    id: "Shape",
    stroke: "#617984",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.8c49a3be91bbee898f2e423858bf6918.svg";
export { ForwardRef as ReactComponent };